import {createSlice} from '@reduxjs/toolkit';
import reducers from './reducers';
import extraReducers from './extraReducers'
import dayjs from 'dayjs';

export * from '../../thunk/removebgLogs';

const RemovebgLogsSlice = createSlice({
    name: "removebgLogs",
    initialState: {
        data: {},
        status: null,
        error: null,
        queryParams: {
            limit: 100,
            page: 1,
            sortDirection: 'DESC',
            maxDate: dayjs().format('YYYY-MM-DD'),
            minDate: dayjs().format('YYYY-MM-DD')
        },
    },
    reducers,
    extraReducers
});
const {actions, reducer} = RemovebgLogsSlice;
export const {setRemovebgLogs, setQueryParams, clearRemovebgFilters} = actions;
export {reducer}; 